// Re-payments being made regularly.
const CURRENT = 1

// Re-payments late.
const LATE = 2

// Late re-payments rescheduled.
const RESCHEDULED = 3

// Re-payments pending confirmation.
const RE_PAYMENT_PENDING_CONFIRMATION = 4

// Re-payments completed on time.
const ON_TIME_FULLY_PAID_OFF = 5

// Re-payments completed recovering less than the principal.
const LATE_FULLY_PAID_OFF = 6

export {
  CURRENT,
  LATE,
  RESCHEDULED,
  RE_PAYMENT_PENDING_CONFIRMATION,
  ON_TIME_FULLY_PAID_OFF,
  LATE_FULLY_PAID_OFF
}

export function getInstallmentState(installmentState) {

  switch (true) {
    case (installmentState === CURRENT):
      return { label: "Pendente", class: "font-on-time", class2: 'current' }
    case installmentState === LATE:
      return { label: "Atrasado", class: "font-late", class2: 'late' }
    case installmentState === RESCHEDULED:
      return { label: "Reagendado", class: "font-atention", class2: 'rescheduled' }
    case installmentState === ON_TIME_FULLY_PAID_OFF || installmentState === RE_PAYMENT_PENDING_CONFIRMATION:
      return { label: "Pago", class: "font-done", class2: 'paid-on-time' }
    case installmentState === LATE_FULLY_PAID_OFF:
      return { label: "Pago atrasado", class: "font-done", class2: 'paid-late' }
    default:
      return { label: "-", class: "font-done", class2: '' }
  }
}
